import {
	BankDataType,
	BeneficiaryRefund,
	FinancialDataType,
	ProfessionalDataType,
	TreatmentDataType,
} from 'domain/usecases';
import {IFile} from '../../components/UploadRefundFiles/types';
import {
	FiscalDocumentSchema,
	PatientDataSchema,
	ProviderDataSchema,
} from './components/ReceiptRegistration/validations';

const enum StepEnum {
	BENEFICIARY_DATA,
	SERVICE_TYPE,
	RECEIPT_REGISTRATION,
	THERAPIES,
	SEND_DOCUMENTS,
	REVIEW,
}

const enum SubmitStatusEnum {
	CREATE_REQUEST = 'CREATE_REQUEST',
	ADD_NEW_REQUEST_IN_PROTOCOL = 'ADD_NEW_REQUEST_IN_PROTOCOL',
	UPDATE_REQUEST = 'UPDATE_REQUEST',
}

type RequestAtomType = {
	bankData: BankDataType;
	protocol: string;
	protocolCode: number;
	requestData: {
		beneficiaryName?: string;
		request: string;
		requestCode: number;
		financialData: FinancialDataType;
		professionalData: ProfessionalDataType;
		treatmentData: TreatmentDataType;
	}[];
};

const enum AccordionExpandedEnum {
	PROVIDER_DATA,
	PATIENT_DATA,
	FISCAL_DOCUMENT,
}

type CustomTreatmentDataType = TreatmentDataType & {
	fullBeneficiary?: BeneficiaryRefund;
};

type FormStatesType = 'account' | 'bank';

enum FormStatesEnum {
	ACCOUNT = 'account',
	BANK = 'bank',
}

type FormChangeDataStateAtomType = {
	formActive: FormStatesType | null;
	isFormDirty: boolean;
};

type RequestFormType = {
	provider: Partial<ProviderDataSchema>;
	patient: Partial<PatientDataSchema>;
	fiscal: Partial<FiscalDocumentSchema>;
	uploads?: IFile[];
};

type RequestContentProps = {
	step: StepEnum;
	firstVisit: boolean;
};

export {StepEnum, SubmitStatusEnum, AccordionExpandedEnum, FormStatesEnum};
export type {
	RequestAtomType,
	CustomTreatmentDataType,
	FormChangeDataStateAtomType,
	RequestFormType,
	FormStatesType,
	RequestContentProps,
};
